import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { parse, stringify } from 'query-string';
import { FormattedMessage } from 'react-intl';
import { object, func } from 'prop-types';
import { Row, Col, Label, FormGroup, Button } from 'reactstrap';
import {
  startSetOffers,
  startSearchOffers,
  resetOffersCatalogFilter,
} from '../../../../actions/offers';
import OffersFilter from '../../../../components/Offers/OffersFilter/OffersFilter';
import OffersSearch from '../../../../components/Offers/OffersSearch';
import { FMessage } from '../../../../hoc/IntlComponents';

export class OffersListFilters extends Component {
  static propTypes = {
    filters: object.isRequired,
    onSearch: func.isRequired,
  };

  constructor(props) {
    super(props);

    const parsedParams = parse(window.location.search);

    this.state = {
      query: parsedParams.search ? parsedParams.search : '',
    };
  }

  handleChange = e => {
    const query = e.target.value;

    this.setState(
      () => ({ query }),
      () => {
        const { query } = this.state;
        this.props.onSearch(query);
      },
    );
  };

  isFilterNotEmpty = name => this.props.filters[name].length;

  handleReset = _ => {
    this.setState({ query: '' }, () => {
      const { tab, limit, page } = parse(window.location.search);
      history.replaceState(
        {},
        null,
        `${window.location.pathname}?${stringify({ tab, limit, page })}`,
      );
      this.props.onSearch('');
      this.props.resetOffersCatalogFilter();
    });
  };

  render() {
    const { query } = this.state;
    const { filters } = this.props;

    if (!Object.keys(filters).length) return null;

    return (
      <Row className="offers-filters-theme-4">
        <Col xs="12" md="6" xl="4">
          <FormGroup>
            <span>
              <FMessage id="offers.filters.label.title" />:
            </span>
            <OffersSearch onChange={this.handleChange} query={query} />
          </FormGroup>

          <FormGroup>
            <span>
              <FMessage id="offers.filters.label.categories" />:
            </span>
            {this.isFilterNotEmpty('categories') ? (
              <FormattedMessage id="offers.filters.categories.theme_4" defaultMessage="Categories">
                {label => (
                  <OffersFilter
                    name="categories"
                    defaultLabel={label}
                    items={filters.categories}
                    search
                  />
                )}
              </FormattedMessage>
            ) : null}
          </FormGroup>

          <FormGroup>
            <span>
              <FMessage id="offers.filters.label.countries" />:
            </span>
            {this.isFilterNotEmpty('countries') ? (
              <FormattedMessage id="offers.filters.countries.theme_4" defaultMessage="Countries">
                {label => (
                  <OffersFilter
                    name="countries"
                    defaultLabel={label}
                    items={filters.countries}
                    search
                  />
                )}
              </FormattedMessage>
            ) : null}
          </FormGroup>
        </Col>
        <Col className="button-col" a xs="12" md="6" xl="4">
          {/*<FormGroup>*/}
          {/*  <span>*/}
          {/*    <FMessage id="offers.filters.label.sources" />:*/}
          {/*  </span>*/}
            {/*{this.isFilterNotEmpty('approved') ? (*/}
            {/*  <FormattedMessage id="offers.filters.sources.theme_4" defaultMessage="Sources">*/}
            {/*    {label => (*/}
            {/*      <OffersFilter*/}
            {/*        name="sources"*/}
            {/*        defaultLabel={label}*/}
            {/*        items={filters.approved}*/}
            {/*        search*/}
            {/*        className="offers_filters_sources"*/}
            {/*      />*/}
            {/*    )}*/}
            {/*  </FormattedMessage>*/}
            {/*) : null}*/}
          {/*</FormGroup>*/}

          <FormGroup>
            <span>
              <FMessage id="offers.filters.label.currencies" />:
            </span>
            {this.isFilterNotEmpty('currencies') ? (
              <FormattedMessage id="offers.filters.currencies.theme_4" defaultMessage="Currencies">
                {label => (
                  <OffersFilter name="currencies" defaultLabel={label} items={filters.currencies} />
                )}
              </FormattedMessage>
            ) : null}
          </FormGroup>
          <Button size="sm" onClick={this.handleReset.bind(null)}>
            <FMessage id="offers.filters.reset" />
          </Button>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = state => ({
  filters: state.offers.filters,
});

const mapDispatchToProps = dispatch => ({
  startSearchOffers: params => dispatch(startSearchOffers(params)),
  startSetOffers: () => dispatch(startSetOffers()),
  resetOffersCatalogFilter: name => dispatch(resetOffersCatalogFilter(name)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OffersListFilters);
